import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'personal-information',
  templateUrl: './personal-information-card.component.html',
  styleUrls: ['./personal-information-card.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PersonalInformationComponent {
  @Input() public info: any;
  @Input() public loading: boolean;
  @Input() public error: string;

  public readonly communicationPreferences = [
    { key: 'globalPref', label: 'All Chick-fil-A emails' },
    { key: 'treatsPref', label: 'Reward emails' },
    { key: 'nationalPref', label: 'National emails' },
    { key: 'localPref', label: 'Local emails' }
  ];

  public get hasCommunicationPreferences(): boolean {
    return !!this.info && this.communicationPreferences.some(pref => this.info[pref.key] !== undefined && this.info[pref.key] !== null);
  }

  public preferenceValue(key: string): string {
    return this.info?.[key] === true ? 'Yes' : 'No';
  }

  public get name() {
    if (this.info && this.info.displayName) {
      return this.info.displayName;
    } else {
      return this.info.name;
    }
  }
}
